// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-container {
  min-height: -moz-fit-content;
  min-height: fit-content;
  min-width: 200px;
  width: 25vw;
  display: flex;
  flex-direction: column;
  background-color: var(--background);
  color: var(--text-color);
}
.dialog-container .communication-error {
  background-color: var(--warn-color);
  border-radius: 5px;
  color: var(--text-color);
  padding: 0.5rem;
  text-align: center;
  margin-bottom: 1rem;
}
.dialog-container .communication-error p {
  margin: 0 !important;
}
.dialog-container mat-form-field {
  margin-top: 0.25rem;
}
.dialog-container mat-form-field.bottom {
  margin-bottom: 1rem;
}
.dialog-container form {
  position: relative;
}
.dialog-container form mat-label {
  color: var(--text-color);
}
.dialog-container mat-icon {
  color: var(--text-color);
  transform: translateY(5px);
}
.dialog-container span {
  color: var(--text-color);
}
.dialog-container button {
  color: var(--text-color);
}
.dialog-container .spinner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--background);
}
.dialog-container .spinner mat-spinner {
  margin: auto;
  vertical-align: middle;
}
.dialog-container .mat-dialog-title {
  display: inline-block;
}
.dialog-container .mat-dialog-title > * {
  vertical-align: middle;
  margin-right: 1rem;
}
.dialog-container .mat-dialog-actions button {
  width: 100%;
}
.dialog-container .mat-dialog-content {
  height: -moz-fit-content;
  height: fit-content;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0;
  padding: 0;
}
.dialog-container .links {
  margin-top: 2rem;
}
.dialog-container .links p {
  cursor: pointer;
  color: var(--turquoise);
  text-decoration: none;
  display: inline-block;
  padding: 0 20px 10px;
  position: relative;
  transition: all 0.3s ease 0.3ms;
  margin-bottom: 0;
}
.dialog-container .links p:after {
  background: none repeat scroll 0 0 transparent;
  bottom: 0;
  content: "";
  display: block;
  height: 2px;
  left: 0;
  position: absolute;
  background: var(--dark-blue);
  transition: width 0.3s ease 0s, left 0.1s ease 0s;
  width: 0;
}
.dialog-container .links p:hover {
  color: var(--dark-blue);
}
.dialog-container .links p:hover:after {
  width: 100%;
  left: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/password-reset/password-reset.component.scss"],"names":[],"mappings":"AAAA;EACE,4BAAA;EAAA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mCAAA;EACA,wBAAA;AACF;AACE;EACE,mCAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AACJ;AACI;EACE,oBAAA;AACN;AAEE;EACE,mBAAA;AAAJ;AAEE;EACE,mBAAA;AAAJ;AAGE;EACE,kBAAA;AADJ;AAGI;EACE,wBAAA;AADN;AAKE;EACE,wBAAA;EACA,0BAAA;AAHJ;AAME;EACE,wBAAA;AAJJ;AAOE;EACE,wBAAA;AALJ;AAQE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,mCAAA;AANJ;AAQI;EACE,YAAA;EACA,sBAAA;AANN;AAUE;EACE,qBAAA;AARJ;AAUI;EACE,sBAAA;EACA,kBAAA;AARN;AAaI;EACE,WAAA;AAXN;AAeE;EACE,wBAAA;EAAA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,SAAA;EACA,UAAA;AAbJ;AAgBE;EACE,gBAAA;AAdJ;AAgBI;EACE,eAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,+BAAA;EACA,gBAAA;AAdN;AAgBM;EACE,8CAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,OAAA;EACA,kBAAA;EACA,4BAAA;EACA,iDAAA;EACA,QAAA;AAdR;AAiBM;EACE,uBAAA;AAfR;AAiBQ;EACE,WAAA;EACA,OAAA;AAfV","sourcesContent":[".dialog-container {\r\n  min-height: fit-content;\r\n  min-width: 200px;\r\n  width: 25vw;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background-color: var(--background);\r\n  color: var(--text-color);\r\n\r\n  .communication-error {\r\n    background-color: var(--warn-color);\r\n    border-radius: 5px;\r\n    color: var(--text-color);\r\n    padding: 0.5rem;\r\n    text-align: center;\r\n    margin-bottom: 1rem;\r\n\r\n    p {\r\n      margin: 0 !important;\r\n    }\r\n  }\r\n  mat-form-field {\r\n    margin-top: 0.25rem;\r\n  }\r\n  mat-form-field.bottom {\r\n    margin-bottom: 1rem;\r\n  }\r\n\r\n  form {\r\n    position: relative;\r\n\r\n    mat-label {\r\n      color: var(--text-color);\r\n    }\r\n  }\r\n\r\n  mat-icon {\r\n    color: var(--text-color);\r\n    transform: translateY(5px);\r\n  }\r\n\r\n  span {\r\n    color: var(--text-color);\r\n  }\r\n\r\n  button{\r\n    color: var(--text-color);\r\n  }\r\n\r\n  .spinner {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: var(--background);\r\n\r\n    mat-spinner {\r\n      margin: auto;\r\n      vertical-align: middle;\r\n    }\r\n  }\r\n\r\n  .mat-dialog-title {\r\n    display: inline-block;\r\n\r\n    & > * {\r\n      vertical-align: middle;\r\n      margin-right: 1rem;\r\n    }\r\n  }\r\n\r\n  .mat-dialog-actions {\r\n    button {\r\n      width: 100%;\r\n    }\r\n  }\r\n\r\n  .mat-dialog-content {\r\n    height: fit-content;\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    margin: 0;\r\n    padding: 0;\r\n  }\r\n\r\n  .links {\r\n    margin-top: 2rem;\r\n\r\n    p {\r\n      cursor: pointer;\r\n      color: var(--turquoise);\r\n      text-decoration: none;\r\n      display: inline-block;\r\n      padding: 0 20px 10px;\r\n      position: relative;\r\n      transition: all 0.3s ease 0.3ms;\r\n      margin-bottom: 0;\r\n\r\n      &:after {\r\n        background: none repeat scroll 0 0 transparent;\r\n        bottom: 0;\r\n        content: \"\";\r\n        display: block;\r\n        height: 2px;\r\n        left: 0;\r\n        position: absolute;\r\n        background: var(--dark-blue);\r\n        transition: width 0.3s ease 0s, left 0.1s ease 0s;\r\n        width: 0;\r\n      }\r\n\r\n      &:hover {\r\n        color: var(--dark-blue);\r\n\r\n        &:after {\r\n          width: 100%;\r\n          left: 0;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
